import { jsx as _jsx } from "react/jsx-runtime";
import { LocaleSwitcher as SharedLocaleSwitcher } from '@packages/locale-switcher';
import { useRouter } from 'next/router';
export default function LocaleSwitcher({ locales = [], translation, }) {
    const router = useRouter();
    return (_jsx(SharedLocaleSwitcher, { menuOffset: 40, locales: locales.map(({ locale, labels }) => ({
            value: locale,
            label: router.locale === 'nb' ? labels.nb : labels.en,
        })), currentLocale: router.locale ?? 'nb', label: translation('navigation.switch_language'), onLocaleChange: (locale) => {
            void router.push(router.asPath, router.asPath, { locale });
        } }));
}
